<template>
  <div class="xb-content">
    <!-- [{ width: windowWidth + 'px' }, { height: windowHeight + 'px' }] -->
    <iframe
      style="width: 100%; height: 100%"
      allowfullscreen="true"
      frameborder="no"
      id="xbIframe"
      :src="iframeUrl"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      iframeUrl: "https://wxt.xkw.com/xb/dashboard",
    };
  },
};
</script>
<style scoped lang="scss">
.xb-content {
  height: 100%;
  overflow-y: hidden;
}
</style>
